'use client';

import { cn } from '@/lib/utils';
import { Article, CategoryWithCount } from '@/types/types';
import { BlogSidebarSection } from './blog-sidebar-section';
import { BrowseCategories } from './browse-categories';
import { MarketingDemo } from './marketing-demo';
import { NewsletterSignup } from './newsletter-signup';

interface DesktopSidebarProps {
	categories: CategoryWithCount[];
	article?: Article;
	searchQuery: string;
	setSearchQuery: (query: string) => void;
	isExpanded: boolean;
	setIsExpanded: (isExpanded: boolean) => void;
	className?: string;
}

export function DesktopSidebar({
	categories,
	article,
	searchQuery,
	setSearchQuery,
	isExpanded,
	setIsExpanded,
	className,
}: DesktopSidebarProps) {
	return (
		<aside
			className={cn(
				'sticky top-10 hidden w-full lg:block lg:w-[280px]',
				className,
			)}>
			<BlogSidebarSection className="pb-8">
				{/* Marketing Demo - Fixed */}
				<div className="mb-6">
					<MarketingDemo stickyTopOffset="7.5rem" />
				</div>

				{/* Divider */}
				<div className="mb-6 border-t border-neutral-200"></div>

				{/* Categories with integrated search */}
				<BrowseCategories
					categories={categories}
					article={article}
					searchQuery={searchQuery}
					setSearchQuery={setSearchQuery}
					isExpanded={isExpanded}
					setIsExpanded={setIsExpanded}
				/>

				{/* Newsletter Signup */}
				<NewsletterSignup />
			</BlogSidebarSection>
		</aside>
	);
}
